import { Navigate, Route, Routes } from "react-router-dom";
import AuthSync from "./components/auth/AuthSync";
import RequireAuth from "./components/auth/RequireAuth";
import AppLayout from "./components/layout/AppLayout";
import AccountPage from "./pages/AccountPage";
import GeneratePage from "./pages/GeneratePage";
import GenerateOrnamentPage from "./pages/GenerateOrnamentPage";
import HomePage from "./pages/HomePage";
import LogoutPage from "./pages/LogoutPage";
import GalleryPillowsPage from "./pages/GalleryPillowsPage";
import GalleryOrnamentsPage from "./pages/GalleryOrnamentsPage";
import GalleryServerlessPage from "./pages/GalleryServerlessPage";
import { JobDetailPage, OrnamentDetailPage, PillowDetailPage } from "./pages/GalleryDetailPage";
import ServerlessPage from "./pages/ServerlessPage";

export default function App() {
  return (
    <>
      <AuthSync />
      <Routes>
        <Route element={<AppLayout />}>
          {/* Public routes. */}
          <Route path="/" element={<HomePage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/logout" element={<LogoutPage />} />

          {/* Authenticated app routes — the guard handles the not-signed-in redirect. */}
          <Route element={<RequireAuth />}>
            <Route path="/generate" element={<Navigate to="/generate/pillows" replace />} />
            <Route path="/generate/pillows" element={<GeneratePage />} />
            <Route path="/generate/ornaments" element={<GenerateOrnamentPage />} />
            <Route path="/generate/serverless" element={<ServerlessPage />} />
            <Route path="/serverless" element={<Navigate to="/generate/serverless" replace />} />
            <Route path="/gallery" element={<Navigate to="/gallery/pillows" replace />} />
            <Route path="/gallery/pillows" element={<GalleryPillowsPage />} />
            <Route path="/gallery/ornaments" element={<GalleryOrnamentsPage />} />
            <Route path="/gallery/serverless" element={<GalleryServerlessPage />} />
            <Route path="/gallery/pillows/:id" element={<PillowDetailPage />} />
            <Route path="/gallery/ornaments/:id" element={<OrnamentDetailPage />} />
            <Route path="/gallery/serverless/:id" element={<JobDetailPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}
